<div class="wrapper">
  <!-- Always-mounted softphone host: stable audio sink + call modal, persists across all authenticated routes -->
  <softphone-host></softphone-host>

  <!-- Always-mounted Internal Chat bubble (FAB + popup) — per-company module gate -->
  @if (getModuleChat()) {
    <chat-bubble-host></chat-bubble-host>
  }

  <div class="navbar-custom">
    <header-component (toggleSidenavEmitter)="sidenav = $event" />
  </div>
  <div class="leftside-menu menuitem-active">
    <sidebar-component [sidenav]="sidenav" />
  </div>

  <div class="content-page" [class.has-footer]="!hideFooter">
    <div class="content">
      <div class="container-fluid">
        <router-outlet />
      </div>
    </div>
    @if (!hideFooter) {
      <footer-component></footer-component>
    }
  </div>
</div>
